import { render, staticRenderFns } from "./NsiItem.vue?vue&type=template&id=322f40ef&scoped=true&"
import script from "./NsiItem.vue?vue&type=script&lang=js&"
export * from "./NsiItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322f40ef",
  null
  
)

export default component.exports